export default {
    path: '/rentlist',
    meta: {
        title: '租约合同',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/rentlist`),
}


// WEBPACK FOOTER //
// ./src/views/RentList/router.js